import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Rest as Desc } from './desk'
import { Rest as Mob } from './mob'
import { TSliderItem } from '../hero-block/types'

type Props = {
  images: TImages
  sliderItems: TSliderItem[]
}
export const Rest: React.FC<Props> = ({ images, sliderItems }) => {
  const { isMobile } = useDimensions()
  return isMobile ? (
    <Mob images={images} sliderItems={sliderItems} />
  ) : (
    <Desc images={images} sliderItems={sliderItems} />
  )
}
